import React, { useState, useEffect } from "react";
import "./Home.css";

import Training from "../../images/ALL/Traning.jpg";
import Practice from "../../images/ALL/Practice.jpg";
import Team from "../../images/TeamPhoto/TP4.jpg";
import Match from "../../images/ALL/Match.jpg";
import Ground from "../../images/ALL/All16.jpg";
import Sachin from "../../images/Coaches/Sachin.jpg";
import Rahul from "../../images/Coaches/RahulSir.jpg";
import Sudarshan from "../../images/Coaches/Sudarshan.jpg";
import Siddhesh from "../../images/Coaches/Siddesh.jpg";
import Mahesh from "../../images/Coaches/Mahesh.jpg";


// Hero images for slideshow
import Hero1 from "../../images/TeamPhoto/TP1.jpg";
import Hero2 from "../../images/ALL/Practice.jpg";
import Hero3 from "../../images/ALL/Traning.jpg";
import Hero4 from "../../images/ALL/All16.jpg";
import Hero5  from "../../images/Events/Event3.jpg";

const Home = () => {
  const [currentHero, setCurrentHero] = useState(0);
  const heroImages = [Hero1, Hero2, Hero3 , Hero4, Hero5];

  // Change hero image every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHero((prev) => (prev + 1) % heroImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const coaches = [
    { name: "Sachin Suryavanshi", role: "Head Coach & Mentor", image: Sachin },
    { name: "Mahesh Bharambe", role: "Coach", image: Mahesh },
    { name: "Siddhesh Darde", role: "Coach", image: Siddhesh },
     { name: "Rahul Bhagat", role: "Coach", image: Rahul },
    { name: "Sudarshan Bansode", role: "Coach", image: Sudarshan },
   
    
  ];

  const programs = [
    { title: "Batting Mastery", desc: "Perfect your stance, shot selection, and power hitting.", icon: "🏏" },
    { title: "Bowling Accuracy", desc: "Master pace, swing, spin, and line control.", icon: "🎯" },
    { title: "Fielding Focus", desc: "Sharpen your reflexes, agility, and catching skills.", icon: "🧤" },
    { title: "Fitness & Conditioning", desc: "Enhance endurance and build athletic strength.", icon: "💪" },
  ];

  const testimonials = [
    { name: "Rahul Sharma", text: "The coaches are amazing! My batting improved in just 2 months.", rating: 5 },
    { name: "Ananya Patel", text: "Professional environment with digital performance tracking.", rating: 5 },
    { name: "Ravi Desai", text: "Great academy with real-time stats and video analysis!", rating: 4 },
  ];

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          background: `linear-gradient(
            rgba(0, 0, 0, 0.4),
            rgba(0, 0, 0, 0.8)
          ), url(${heroImages[currentHero]}) center/cover no-repeat`,
          transition: "background 1s ease-in-out",
        }}
      >
        <div className="hero-overlay">
          <h1>
            <span className="highlight">3S Sports</span> Cricket Academy
          </h1>
          <p>Train. Perform. Excel. The Digital Way.</p>
          <a href="#programs" className="cta-btn">
            Explore Programs
          </a>
        </div>
        <div className="scroll-indicator">↓</div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <h2>About Our Academy</h2>
        <p>
        Welcome to <strong> 3S Sports Cricket Academy</strong> — where cricket training meets innovation and excellence. Our platform combines expert coaching with performance-focused techniques, making your game sharper, faster, and smarter. Experience training like never before, where passion meets precision and every session is designed to bring out the best in you.
        </p>
      </section>

      {/* Senior Coach Message */}
      <section className="mentor-message-section">
        <div className="mentor-card">
          <img src={Sachin} alt="Head Coach" className="mentor-image" />
          <div className="mentor-text">
            <h3>Mr. Sachin Suryavanshi</h3>
            <p className="mentor-role">Head Coach & Mentor</p>
            <p>
              "As the Head Coach and Mentor at <strong> 3S Sports Cricket Academy </strong>, my mission is to nurture not just skilled cricketers, but disciplined, confident, and resilient athletes. We combine the wisdom of traditional coaching with advanced performance techniques to help every player unlock their true potential."
            </p>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section id="programs" className="programs-section">
        <h2>Our Elite Programs</h2>
        <div className="programs-grid">
          {programs.map((prog, index) => (
            <div className="program-card" key={index}>
              <span className="program-icon">{prog.icon}</span>
              <h3>{prog.title}</h3>
              <p>{prog.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Coaches Section */}
      <section id="coaches" className="coaches-section">
        <h2>Meet Our Coaches</h2>
        <div className="coaches-grid">
          {coaches.map((coach, index) => (
            <div className="coach-card" key={index}>
              <img src={coach.image} alt={coach.name} />
              <div className="coach-info">
                <h3>{coach.name}</h3>
                <p>{coach.role}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <h2>Players’ Voices</h2>
        <div className="testimonials-grid">
          {testimonials.map((t, index) => (
            <div className="testimonial-card" key={index}>
              <p className="testimonial-text">“{t.text}”</p>
              <div className="testimonial-rating">{"⭐".repeat(t.rating)}</div>
              <h4>- {t.name}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <h2>Academy Highlights</h2>
        <div className="gallery-grid">
          <img src={Training} alt="Training" />
          <img src={Practice} alt="Practice" />
          <img src={Match} alt="Match" />
          <img src={Team} alt="Team" />
          <img src={Ground} alt="Team" />
        </div>
      </section>

     
    </div>
  );
};

export default Home;
